import BookingGetters from "../../../store/onlineBooking/getters";
export const useBookingConfig = () => {
  const AppSettings = BookingGetters.getAppSettings();
  return {
    maxRentalAllowedDay: AppSettings?.maxRentalDurationInDays || 30,
    minRentalAllowedDay: AppSettings?.minRentDays || 0,
  };
};
